import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import { ApiGet, ApiPut, ApiDelete, ApiPost } from "../../../helpers/API/ApiData";
import { customStyles } from "../tableStyle";
import { TailSpin } from "react-loader-spinner";
import "./allLeads.scss";
import { toast } from "react-toastify";
import useDebounce from "../../../hooks/useDebounceHook";
import Moment from "react-moment";
import Select from "react-select";
import "moment-timezone";
// import AddLeadDetails from "../Stepper/addNewLead/AddLeadDetails";

export default function AllLeads() {
  const [getNewsData, setGetNewsData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [countForModel, setCountForModel] = useState(0);
  const [close, setclose] = useState("");
  const [image, setimage] = useState("");
  const [fileType, setfileType] = useState("");
  const [loading, setLoading] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue, 900);
  const [userName, setUserName] = useState([]);

  const [selectedFile, setSelectedFile] = useState({
    file: null,
    filename: "",
  });

  const [pageCompany, setPageCompany] = useState(1);
  const [companyName, setCompanyName] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [sortFirma, setSortFirma] = useState();
  const [selectedCompanyName, setSelectedCompanyName] = useState([]);

  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [search, setSearch] = useState();
  const [newpage, setNewPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [userData, setUserData] = useState();
  const [assignOption, setAssignOption] = useState();

  const assignLeadOption = [
    {
      value: true,
      label: "zugeteilt",
    },
    {
      value: false,
      label: "nicht zugeteilt",
    },
  ];

  const handleSortData = () => {
    setSortFirma(sortFirma == "asc" ? "desc" : "asc");
  };

  const columns = [
    {
      name: "SNo",
      cell: (row, index) => {
        return <p>{(page - 1) * countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: <span>Vertriebspartner</span>,
      minWidth: "250px",
      selector: (row) => (
        <div
          className="profileImage"
          style={{
            display: "flex",
            gap: "10px",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          {row.assignUid?.length
            ? row.assignUid
              ?.map((item) => item.name)
              .join(", ")
              .slice(0, 20)
            : "Nicht zugewiesen"}
        </div>
      ),
    },

    {
      name: <span>status</span>,
      width: "250px",
      selector: (row) => {
        const statusClass = row?.status == "offen" || row?.status == "NICHT ERREICHT" || row?.status == "ZEITLICHE VERZÖGERUNG" ? "new-deisgnpppppppppp" : row?.status == "STORNO" ? "new-deisgn-statusooooooooooo" : "newstatusppppppppppp";

        return <div className={statusClass}>{row.status ? row.status : "-"}</div>;
      },
    },
    {
      name: <span>Datum </span>,
      minWidth: "200px",
      selector: (row) => <div className="profileImage">{row.createdAt ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={row.createdAt} /> : "-"}</div>,
    },
    {
      name: (
        <>
          <span>Firma</span>
          <div onClick={() => handleSortData()} className="sort-button">
            {sortFirma === "desc" ? (
              <div className="up-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                  <path d="M12 4V20M12 4L8 8M12 4L16 8" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            ) : (
              <div className="down-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                  <path d="M12 4V20M12 20L8 16M12 20L16 16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            )}
          </div>
        </>
      ),
      width: "250px",
      selector: (row) => <div className="profileImage">{row.firma ? row.firma : "-"}</div>,
    },
    {
      name: "Anrede",
      width: "100px",
      selector: (row) => <div className="profileImage">{row.contractions ? row.contractions : "-"}</div>,
    },

    {
      name: "Vorname ",
      width: "200px",
      selector: (row) => <div className="profileImage">{row.name ? row.name : "-"}</div>,
    },

    {
      name: " Nachname",
      width: "200px",
      selector: (row) => <div className="profileImage">{row.nachname ? row.nachname : "-"}</div>,
    },

    {
      minWidth: "300px",
      name: " Adresse",
      selector: (row) => (
        <div className="profileImage" style={{ "white-space": "normal" }}>
          {row.strabe ? row.strabe : "-"}
        </div>
      ),
    },

    {
      minWidth: "150px",
      name: "Postleitzahl",
      selector: (row) => <div className="profileImage">{row.pLZ ? row.pLZ : "-"}</div>,
    },

    {
      minWidth: "150px",
      name: "Ort",
      selector: (row) => <div className="profileImage">{row.location ? row.location : "-"}</div>,
    },

    {
      minWidth: "150px",
      name: "Kontakt",
      selector: (row) => <div className="profileImage">{row.telephon ? row.telephon : "-"} </div>,
    },

    {
      name: "E-mail",
      width: "300px",
      selector: (row) => <div className="profileImage">{row.email ? row.email : "-"}</div>,
    },

    {
      minWidth: "300px",
      name: "wichtige Informationen",
      selector: (row) => (
        <div className="profileImage" style={{ "white-space": "normal" }}>
          {row.notizen && row.notizen !== "undefined" ? row.notizen : "-"}
        </div>
      ),
    },
  ];

  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      maxWidth: "200px",
      marginLeft: "20px",
      fontSize: "12px",
      border: state.isFocused ? "2px solid #73AA85 !important" : "",
      boxShadow: "1px solid #73AA85 !important",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      color: state.isSelected ? "white" : "black",
      backgroundColor: state.isSelected ? "#73AA85" : "white",
      "&:hover": {
        backgroundColor: "#73AA85",
      },
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "200px",
      marginLeft: "20px",
      zIndex: "999",
    }),
  };
  const ProjectStyle = {
    control: (provided, state) => ({
      ...provided,
      maxWidth: "150px",
      fontSize: "12px",
      marginLeft: "30px",
      border: state.isFocused ? "2px solid #73AA85 !important" : "",
      boxShadow: "1px solid #73AA85 !important",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      color: state.isSelected ? "white" : "black", // Change selected color here
      backgroundColor: state.isSelected ? "#73AA85" : "white",
      "&:hover": {
        backgroundColor: "#73AA85",
      },
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "150px",
      marginLeft: "30px",
      zIndex: "999",
    }),
  };

  useEffect(() => {
    handleChangeCommom("", "", filterData);
  }, [debouncedSearchValue, page, countPerPage, assignOption, selectedCompanyName, sortFirma]);

  useEffect(() => {
    const handleGetSalesPatner = async () => {
      try {
        const response = await ApiGet(`user/get`);
        const data = response?.data?.payload?.data;
        if (data && Array.isArray(data)) {
          const optionData = data.map((item) => ({
            value: item?.userId,
            label: item?.name,
          }));

          setUserName(optionData);
        }
      } catch (error) {
        toast.error("Vertriebspartner konnten nicht abgerufen werden..");
      }
    };

    const handleGetProject = async () => {
      await ApiGet(`project/get`)
        .then((response) => {
          const data = response?.data?.payload.data;
          const optionData = data?.map((item) => ({
            value: item._id,
            label: item.projectname,
          }));
          setProjectOptions(optionData);
        })
        .catch((error) => {
          toast.error(error);
        });
    };

    handleGetSalesPatner();
    handleGetProject();
    handleGetAllCompany(pageCompany);
  }, []);

  // Function to fetch data for the dropdown (paginated API call)
  const handleGetAllCompany = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await ApiGet(`vattenfall/uniqueFirma?page=${pageNumber}&limit=10`);
      const data = response?.data?.payload;

      if (data && Array.isArray(data)) {
        const optionData = data.map((item) => ({
          value: item?.firma,
          label: item?.firma,
        }));

        setCompanyName((prevOptions) => [...prevOptions, ...optionData]);
        if (data.length === 0) {
          setHasMore(false); // No more data available
        }
      }
    } catch (error) {
      // toast.error("Vertriebspartner konnten nicht abgerufen werden..");
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCommom = async (e, key, filter) => {
    let updatedFilter = { ...filterData };

    if (!e && key) {
      if (key == "userId") {
        setSelectedUserName("");
      } else if (key == "projectName") {
        setSelectedProject("");
      }

      if (key === "startDate" || key === "endDate") {
        updatedFilter.startDate = "";
        updatedFilter.endDate = "";
      } else {
        updatedFilter[key] = "";
      }
    } else {
      if (key == "userId") {
        updatedFilter = {
          ...filterData,
          [`${key}[]`]: e.map((item) => item.value),
        };
      } else {
        updatedFilter = key ? { ...filterData, [key]: e.label } : filter;
      }
    }

    setLoading(true);
    let ddd = "";
    for (const [key, value] of Object.entries(updatedFilter)) {
      if (Array?.isArray(value)) {
        for (const v of value) {
          ddd += `${key}=${v}&`;
        }
      } else if (value) {
        const data = encodeURIComponent(value);
        ddd += `${key}=${data}&`;
      }
    }

    let body = {
      firma:
        selectedCompanyName?.length > 0
          ? selectedCompanyName
            .map((item) => item.value.replace(/"/g, "")) // Remove quotes from each value
            .join(",")
          : "",
    };

    try {
      const response = await ApiPost(
        `straper/getVattenfall?${ddd}&limit=${countPerPage}&page=${page}${debouncedSearchValue ? `&search=${searchValue}` : ""}${assignOption ? `&isAssign=${assignOption?.value}` : ""}  ${sortFirma ? `&sortFirma=${sortFirma}` : ""}`,
        body
      );
      const data = response?.data?.payload.data;
      setCount(response?.data?.payload.count);
      if (key == "userId") {
        setSelectedUserName(e);
      } else if (key == "projectName") {
        setSelectedProject(e);
      }
      setGetNewsData(data);
      setLoading(false);
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }

    setFilterData(updatedFilter);
  };

  const customNoDataComponent = () => <div style={{ textAlign: "center", padding: "10px 0px", fontSize: "16px" }}>Aktuell sind keine Daten vorhanden.</div>;

  const getUserData = async () => {
    await ApiGet(`user/get?page=${newpage}&limit=${limit}${search ? `&search=${search}` : ""}`)
      .then((response) => {
        const data = response?.data?.payload.data;
        setCountForModel(response?.data?.payload.count / 10);
        setUserData(response?.data?.payload.data);

        // const activeData = data.filter((jobData) => {
        //   return jobData.roleId._id == "65fc2112e8fe93f708e798c3";
        // });
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  useEffect(() => {
    getUserData();
  }, [newpage, limit, search]);

  const handleChangeAssign = (data) => {
    setAssignOption(data);
  };

  const handleSelectCompany = (e) => {
    if (!e) {
      setSelectedCompanyName("");
    } else {
      setSelectedCompanyName(e);
    }
  };

  const handleApply = async (selectedOption, startDate, endDate) => {
    if (!startDate || !endDate) {
      handleChangeCommom("", "startDate");
    } else {
      const timezoneOffset = startDate.getTimezoneOffset() * 60000; // in milliseconds
      startDate = new Date(startDate - timezoneOffset);
      endDate = new Date(endDate - timezoneOffset);
      startDate = startDate.toISOString().split("T")[0];
      endDate = endDate.toISOString().split("T")[0];
      const params = { ...filterData, startDate: startDate, endDate };
      setFilterData(params);
      handleChangeCommom("", "", params);
    }
  };

  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="row mb-4 pr-3 " style={{ flexDirection: "column" }}>
            <div className="d-flex gap-20 Vattenfall-mobile-title vattenfall-title">
              <h2 className="pt-2 mr-5">Alle Leads</h2>
              a
              <div className="header-items">
                <input
                  type="search"
                  className={`form-control form-control-lg form-control-solid `}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setLoading(true);
                  }}
                  name="search"
                  value={searchValue}
                  placeholder="Suche"
                />
              </div>
            </div>
            <div>
              <div className="row-mobile-collg8main vattenfall-mobile-header-rs header-main-inputs-layout">
                {/* <div className="date-filter header-items">
                  <DateFilter onApply={handleApply} className="Datefilter-flx-mobile-main" />
                </div> */}
                {/* <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="dropdown-align "
                      value={selectedCompanyName}
                      name="companyName"
                      onChange={(e) => {
                        handleSelectCompany(e);
                      }}
                      placeholder="Firmennamen"
                      options={companyName}
                      maxHeight={"40px"}
                      defaultValue={selectedCompanyName}
                      isClearable={true}
                      isMulti
                      styles={customStyle}
                    />
                  </div>
                </div> */}

                {/* <div className="header-items">
                  <div className="project-Dropdown project-Dropdown-sc">
                    <Select
                      className="Select-main"
                      // menuIsOpen={true}
                      value={assignOption}
                      name="isAssign"
                      onChange={(e) => handleChangeAssign(e, "isAssign")}
                      options={assignLeadOption}
                      styles={ProjectStyle}
                      defaultValue={assignOption}
                      placeholder="zugeteilt"
                      isClearable={true}
                    />
                  </div>
                </div> */}

                {/* <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="Select-main"
                      // menuIsOpen={true}
                      value={selectedProject}
                      name="projectName"
                      onChange={(e) => handleChangeCommom(e, "projectName")}
                      options={projectOptions}
                      styles={ProjectStyle}
                      defaultValue={selectedProject}
                      placeholder="Projekt "
                      isClearable={true}
                    />
                  </div>
                </div> */}

                {/* <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="dropdown-align "
                      value={selectedUserName}
                      name="userName"
                      onChange={(e) => {
                        handleChangeCommom(e, "userId");
                      }}
                      placeholder="Vertriebspartner"
                      options={userName}
                      maxHeight={"40px"}
                      defaultValue={selectedUserName}
                      isClearable={true}
                      isMulti
                      styles={customStyle}
                    />
                  </div>
                </div> */}

                {/* <div className="header-items">
                  <input
                    type="search"
                    className={`form-control form-control-lg form-control-solid `}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      setLoading(true);
                    }}
                    name="search"
                    value={searchValue}
                    placeholder="Suche"
                  />
                </div> */}
              </div>
            </div>
          </div>
          <DataTable
            data={getNewsData}
            columns={columns}
            responsive
            noDataComponent={customNoDataComponent()}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={page}
            progressPending={loading}
            progressComponent={
              <div className="LoadinComponent">
                <TailSpin color="#334D52" height={30} width={30} />
              </div>
            }
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
            fixedHeader
          />
        </div>
      </div>

      {close && (
        <div className="new__imagemodel">
          <div className="body_model"></div>
          <div className="new-white-box">
            <div className="header_close">
              <i
                onClick={() => {
                  setclose(!close);
                  setimage("");
                }}
                className="fas fa-window-close modalClose"
              ></i>
            </div>
            <div className="image_body">
              {fileType == "svg" || fileType == "png" || fileType == "jpg" || fileType == "jpeg" ? (
                <>
                  <img className="modal-image" src={image} />
                </>
              ) : fileType === "pdf" ? (
                <>
                  <object data={image} type="application/pdf" width="420px" height="650px"></object>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
